module.exports = __webpack_public_path__ + "img/selected4-min.ff5169b2.png";